// SSR stub for zod — handles both `import { z } from 'zod'` and `import * as z from 'zod'`
function createSchema(): any {
  const schema: any = new Proxy(() => schema, {
    get(_, prop) {
      if (prop === 'parse' || prop === 'parseAsync') return (v: any) => v
      if (prop === 'safeParse' || prop === 'safeParseAsync') return (v: any) => ({ success: true, data: v })
      if (prop === '_type' || prop === '_output' || prop === '_input' || prop === '_def') return {}
      if (prop === Symbol.toPrimitive || prop === Symbol.iterator) return undefined
      if (typeof prop === 'symbol') return undefined
      return (..._args: any[]) => createSchema()
    },
    apply() {
      return createSchema()
    },
  })
  return schema
}

const z = createSchema()

// Named exports for `import * as z from 'zod'` pattern
export const string = (..._args: any[]) => createSchema()
export const number = (..._args: any[]) => createSchema()
export const boolean = (..._args: any[]) => createSchema()
export const object = (..._args: any[]) => createSchema()
export const array = (..._args: any[]) => createSchema()
export const literal = (..._args: any[]) => createSchema()
export const union = (..._args: any[]) => createSchema()
export const intersection = (..._args: any[]) => createSchema()
export const tuple = (..._args: any[]) => createSchema()
export const record = (..._args: any[]) => createSchema()
export const nativeEnum = (..._args: any[]) => createSchema()
export const optional = (..._args: any[]) => createSchema()
export const nullable = (..._args: any[]) => createSchema()
export const discriminatedUnion = (..._args: any[]) => createSchema()
export const any = (..._args: any[]) => createSchema()
export const unknown = (..._args: any[]) => createSchema()
export const never = (..._args: any[]) => createSchema()
export const void_ = (..._args: any[]) => createSchema()
export const date = (..._args: any[]) => createSchema()
export const bigint = (..._args: any[]) => createSchema()
export const symbol = (..._args: any[]) => createSchema()
export const undefined_ = (..._args: any[]) => createSchema()
export const null_ = (..._args: any[]) => createSchema()
export const lazy = (..._args: any[]) => createSchema()
export const promise = (..._args: any[]) => createSchema()
export const effectsType = (..._args: any[]) => createSchema()
export const transformer = (..._args: any[]) => createSchema()
export const preprocess = (..._args: any[]) => createSchema()
export const pipeline = (..._args: any[]) => createSchema()
export const custom = (..._args: any[]) => createSchema()
export const coerce = createSchema()
export const enum_ = (..._args: any[]) => createSchema()

export { z }
export default z

export class ZodError extends Error {
  issues: any[] = []
}
export type infer<T = any> = T
